<div class="toast-container toast-top-right">
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      class="ngx-toastr"
      [class]="toast.classname"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      (hidden)="toastService.remove(toast)"
    >
      <div class="toast-message">
        <span [innerHTML]="toast.body | trustSrc"></span>
      </div>
    </ngb-toast>
  }
</div>
